// theme.ts
import { createTheme } from '@mui/material/styles';
import { colorCodes } from './data/colors';
import './mui-overrides.d.ts';

const baseTheme = createTheme({
    typography: {
        fontFamily: `'Helvetica Neue', Helvetica, Arial, 'Roboto', sans-serif`,
    },

    shape: {
        borderRadius: 12,
    },

    palette: {
        primary: {
            main: colorCodes.intelliGreen,
            dark: colorCodes.intelliDarkGreen,
            light: colorCodes.intelliLightGreen,
            contrastText: '#FFF',
        },
        secondary: {
            main: colorCodes.intelliBlue,
            light: colorCodes.intelliLightBlue,
        },
        background: {
            default: colorCodes.intelliBlue,
            paper: colorCodes.intelliBlue,
        },
        text: {
            primary: '#FFF',
            secondary: colorCodes.intelliGreen,
        },
        action: {},
    },
});

// Second pass: add component overrides + variants
const theme = createTheme(baseTheme, {
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    border: '1px solid',
                    borderColor: baseTheme.palette.primary.dark,
                    backgroundColor: baseTheme.palette.background.default,
                },
            },
            // variants belong here, NOT inside styleOverrides.root
            variants: [
                {
                    props: { variant: 'gradient' },
                    style: {
                        backgroundImage: `linear-gradient(
              0deg,
              ${baseTheme.palette.secondary.main},
              ${baseTheme.palette.primary.dark}
            )`,
                        color: baseTheme.palette.primary.contrastText,
                    },
                },
            ],
        },
    },
});

export default theme;
